// extracted by mini-css-extract-plugin
export default {"certPassword":"FzZghPl9VSf4gJsELbK_","explaination":"gK44YZiyiLV1Y2BaQduN"};